import {Configuration} from "./src/Types/Configuration";
import {Application} from "./src/Types/Application";
import {DesktopEntry} from "./src/Components/Desktop";

const applicationData: Application[] = [];
['files', 'camera', "calculator", "music", "notepad", "settings", "terminal"].forEach(id => {
    applicationData.push({
        id: `${id}`,
        title: `${id}`,
        url: `/apps/${id}/index.html`,
        icon: `/apps/${id}/icon.svg`
    })
});


const desktopEntryData: DesktopEntry[] = [
    {
        name: "resume",
        icon: "./img/icons/pdf-file.svg",
        type: "file",
        url: "/files/resume.html",
    }
];

export const userConfiguration: Configuration = {
    BackgroundProvider: (): string => "./img/wallpapers/background.jpeg",
    ApplicationProvider: (): Array<Application> => applicationData,
    DesktopEntryProvider: (): Array<DesktopEntry> => desktopEntryData,
    PinnedApplicationProvide: (): Array<Application> => applicationData.filter(app => ["Files", "Camera", "Settings", "Terminal", "MediaPlayer"].find(id => app.title === id) !== undefined),
};